import { Theme } from '@mui/material/styles'
export const getStyles = (theme: Theme) => ({
  card: {
    padding: theme.spacing(1),
    minwidth: '700px',
    height: '100%',
    lineHeight: '21px',
  },

  summaryText: {
    marginTop: theme.spacing(3),
  },

  root: {
    backgroundColor: theme.palette.common.white,
    width: '100%',
  },

  title: {
    fontFamily: 'Source Sans Pro Semibold',
    fontSize: '28px',
  },

  infoTooltip: {
    marginLeft: theme.spacing(0.5),
  },
})
